import React, { Component } from "react";
import StreamChatService from './chat/service';
import Conversations from "./components/Conversations";

import styles from './styles/general.module.scss';
import {userRoles} from "./local_roles";

class SimpleChatWidget extends Component {
  static defaultProps = {
    openDir: 'left',
    title: '',
    hideUsers: false,
    showHelp: false,
    showQA: false,
  };

  constructor(props) {
    super(props);

    this.state = {
      chatClient: null,
      user: null,
      offset: 0
    };
    
    this.pullingUsers = false;
    this.canPullUsers = true;

    this.streamChatService = new StreamChatService(props.streamApiKey);
  }

  componentDidMount = async () => {
    const {accessToken, streamApiKey, apiBaseUrl, forumSlug, onAuthError} = this.props;

    if (accessToken) {
      await this.streamChatService.initialiseClient(streamApiKey, apiBaseUrl, accessToken, forumSlug, this.initCallback, onAuthError);
    }

    window.addEventListener('beforeunload', this.chatCleanup);
  };

  componentWillUnmount() {
    this.chatCleanup();
    window.removeEventListener('beforeunload', this.chatCleanup);
  }

  chatCleanup = async () => {
    const {chatClient} = this.state;
    await chatClient.disconnect();
    this.setState({ chatClient: null, user: null });
  };

  initCallback = (chatClient, user) => {
    if (user) {
      this.setState({chatClient, user}, () => this.pullUsers(0));
    }
  };

  pullUsers = async (offset) => {
    const {chatClient} = this.state;

    const {users} = await chatClient.queryUsers(
        { local_role: {$in : userRoles} },
        { name: 1},
        { presence: true, offset: offset },
    ).then((data) => {
      this.pullingUsers = false;
      return data;
    });

    this.setState({offset: offset + users.length});
  };

  onScroll = async (e) => {
    if (!this.pullingUsers) {
      if (this.wrapperRef.offsetHeight + this.wrapperRef.scrollTop >= this.wrapperRef.scrollHeight) {
        if (this.canPullUsers) {
          this.canPullUsers = false;
          await this.pullUsers(this.state.offset);
        }
      } else {
        this.canPullUsers = true;
      }
    }
  };

  startOneToOneChat = (partnerId) => {
    this.conversationRef && this.conversationRef.startOneToOneChat(partnerId)
  }

  render() {
    const {chatClient, user} = this.state;
    const {openDir, title, hideUsers, showHelp, showQA} = this.props;

    return (
      <div className={styles.widgetWrapper}>
        {title &&
        <nav className="navbar">
          <span className="navbar-brand title">{title}</span>
        </nav>
        }
        {chatClient && user &&
        <div className={styles.sideBar} ref={el => this.wrapperRef = el} onScroll={this.onScroll}>
          <Conversations
              chatClient={chatClient}
              user={user}
              openDir={openDir}
              hideUsers={hideUsers}
              showHelp={showHelp}
              showQA={showQA}
              pullUsers={this.pullUsers} 
              childRef={ref => (this.conversationRef = ref)}
          />
        </div>
        }
      </div>
    );
  }
}

export default SimpleChatWidget;
